<template>
    <div>
      <div class="btn-group" v-if="payStatus === 3">
        <el-button size="mini" type="primary" icon="el-icon-delete" @click="batchDeleteOrder">删除</el-button>
<!--        <el-button size="mini" type="primary" icon="el-icon-present" @click="batchPayOrder">支付</el-button>-->
      </div>
      <el-table
          :data="tableData"
          size="mini"
          ref="orderTable"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          border
          style="width: 100%">
          <el-table-column
            type="selection"
            width="40">
          </el-table-column>
          <el-table-column
            fixed
            prop="outTradeNo"
            label="订单号"
            :show-overflow-tooltip="true"
            width="auto">
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="packageType"-->
<!--            label="套餐"-->
<!--            width="auto">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="packageNum"-->
<!--            label="数量"-->
<!--            width="auto">-->
<!--          </el-table-column>-->
          <el-table-column
            prop="createDate"
            label="创建日期"
            width="auto">
            <template slot-scope="scope">
              <span>{{scope.row.createDate | dateFormat("YYYY-MM-DD HH:mm:ss")}}</span>
            </template>
          </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="金额（元）"
          width="auto">
          <template slot-scope="scope">
            <span>{{scope.row.totalAmount}}</span>
          </template>
        </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            width="auto">
            <template slot-scope="scope">
              <span>{{showStatus(scope.row.payStatus)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="auto">
            <template slot-scope="scope">
              <el-button @click="showDetail(scope.row)" type="text" size="small">详情</el-button>
<!--              已支付状态的可申请退款-->
              <el-button @click="refundOrder(scope.row)" type="text" size="small" v-if="scope.row.payStatus === 2">退款</el-button>
              <el-button @click="payOrder(scope.row)" type="text" size="small" v-if="scope.row.payStatus === 1">支付</el-button>
              <el-button @click="deleteOrder(scope.row)" type="text" size="small" v-if="scope.row.payStatus !== 2 && scope.row.payStatus !== 4">删除</el-button>
              <el-button type="text" size="small" v-if="scope.row.payStatus === 2 || scope.row.payStatus === 4" disabled>删除</el-button>
            </template>
          </el-table-column>
        </el-table>

      <div v-if="showDetailFlag">
        <el-dialog
          title="订单详情"
          :visible.sync="showDetailFlag"
          width="1000px"
          :before-close="handleCloseDetail">
          <el-table
            :data="detailTableData"
            size="mini"
            ref="orderTable"
            tooltip-effect="dark"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="applyName"
              label="申请人姓名"
              :show-overflow-tooltip="true"
              width="auto">
            </el-table-column>
            <el-table-column
              fixed
              prop="phone"
              label="手机号"
              :show-overflow-tooltip="true"
              width="auto">
            </el-table-column>
            <el-table-column
              fixed
              prop="city"
              label="参保城市"
              :show-overflow-tooltip="true"
              width="auto">
            </el-table-column>
            <el-table-column
              fixed
              prop="cardinality"
              label="参保基数(元)"
              :show-overflow-tooltip="true"
              width="auto">
            </el-table-column>
            <el-table-column
              fixed
              prop="feePackageIds"
              label="套餐"
              :show-overflow-tooltip="true"
              width="auto">
            </el-table-column>
            <el-table-column
              fixed
              prop="socialSecurityPrice"
              label="社保价格(元)"
              :show-overflow-tooltip="true"
              width="auto">
            </el-table-column>
            <el-table-column
              fixed
              prop="allCountMoney"
              label="总计金额(元)"
              :show-overflow-tooltip="true"
              width="auto">
            </el-table-column>
          </el-table>
        </el-dialog>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Order',
  props: ['payStatus'],
  data () {
    return {
      selectedOrders: [],
      tableData: [],
      detailTableData: [],
      showDetailFlag: false,
      feePackage: {}
    }
  },
  methods: {
    handleCloseDetail (done) {
      this.showDetailFlag = false
      done()
    },
    handleSelectionChange (val) {
      this.selectedOrders = val
    },
    batchDeleteOrder () {
      console.log(this.selectedOrders)
    },
    batchPayOrder () {
      console.log(this.selectedOrders)
    },
    showStatus (payStatus) {
      let res = '--'
      switch (payStatus) {
        case 1:
          res = '未支付'
          break
        case 2:
          res = '已支付'
          break
        case 3:
          res = '已完成'
          break
        case 4:
          res = '退款'
          break
        default:
          break
      }
      return res
    },
    showDetail (row) {
      this.$http.get(this.$api.getOrderInfoById.url, {id: row.id}).then(_ => {
        if (_ && _.code === 200 && _.data.listSocialSecurity) {
          this.detailTableData = _.data.listSocialSecurity.map(item => {
            return {
              applyName: item.applyName,
              phone: item.phone,
              city: item.socialStandardPojo.city,
              cardinality: (item.cardinality / 100).toFixed(2),
              feePackageIds: this.feePackageShow(item.feePackageIds),
              allCountMoney: (item.allCountMoney / 100).toFixed(2),
              socialSecurityPrice: (item.socialSecurityPrice / 100).toFixed(2)
            }
          })
        }
        this.showDetailFlag = true
        console.log(_)
      })
    },
    feePackageShow (feePackageIds) {
      let f = JSON.parse(feePackageIds)
      let res = ``
      f.forEach(item => {
        res += `${this.feePackage[item.packageId]}(${item.amount}份);`
      })
      return res
    },
    refundOrder (row) {
      console.log(row)
    },
    payOrder (row) {
      this.$api.createQRcode.params.outTradeNo = row.outTradeNo
      this.$api.createQRcode.params.totalAmount = parseFloat(row.totalAmount)
      this.$http.post(this.$api.createQRcode.url, this.$api.createQRcode.params).then(_ => {
        if (_ && _.code === 200 && _.data && _.data.qrCode) {
          this.$emit('qrCodeEvent', _.data.qrCode)
        } else if (_ && !_.data.qrCode && _.data.subMsg) {
          this.$message.error(_.data.subMsg)
        }
      })
    },
    deleteOrder (row) {
      this.$confirm('确定删除订单么？')
        .then(_ => {
          console.log(row)
          this.$http.delete(this.$api.deleteOrder.url, {
            id: row.id
          }).then(_ => {
            if (_ && _.code === 200) {
              this.$message.success('删除成功！')
            }
          })
        })
        .catch(_ => {})
    },
    initOrderTable () {
      this.$http.get(this.$api.getAllOrderInfo.url, {
        payStatus: this.payStatus
      }).then(_ => {
        if (_ && _.code === 200) {
          let data = _.data || []
          this.tableData = data.map(item => {
            return {
              id: item.id,
              createDate: item.createDate,
              totalAmount: item.totalAmount.toFixed(2),
              discountablemount: item.discountablemount,
              outTradeNo: item.outTradeNo,
              payStatus: item.payStatus,
              status: item.status
            }
          })
        }
      })

      this.$http.get(this.$api.getAllActivityPackage.url).then(_ => {
        if (_ && _.code === 200) {
          // this.feePackage = _.data
          _.data.forEach(item => {
            this.feePackage[item.id] = item.servicePeriod
          })
        }
      })
    }
  },
  created () {
    this.initOrderTable()
  }
}
</script>

<style scoped>
.btn-group {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/SocialSecurity/Order.vue